import WidgetUploadDocumentRequestModelBase from '../_generated/modelBases/widget-upload-document-request-model-base';

export default class WidgetUploadDocumentRequestModel extends WidgetUploadDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
